import BaseRequest from "./BaseRequest";
import SingletonBootConfig from "./SingletonBootConfig";

export default class SurveyRequest {
  static get = async () => {
    let surveysfolder = window["boot"].path;
    let path = `${process.env.PUBLIC_URL}${surveysfolder}/survey.xml`;
    return await BaseRequest.GetJsonFromXMLRequest(path);
  };

  static fakePostSurvey = async xmlFile => {
    let path =
      SingletonBootConfig.getInstance().getChatWS() + "/requestSaveSurvey";
    return await BaseRequest.GetXMLRequest(path, {
      xmlFile
    });
  };
}
